const STORE_KEY = 'evenly_guest_tabs';
const MANUAL_MEMBER_MAP_KEY = 'evenly_guest_map';

type GuestTabMap = Record<string, string>;

export const GuestService = {
    // Get list of tab IDs the guest has "joined" (viewed/interacted with)
    getGuestTabs: (): string[] => {
        try {
            const stored = localStorage.getItem(STORE_KEY);
            return (stored ? JSON.parse(stored) : []) as string[];
        } catch {
            return [];
        }
    },

    // Save a tab ID to the guest's list
    saveGuestTab: (tabId: string) => {
        try {
            const tabs = GuestService.getGuestTabs();
            if (!tabs.includes(tabId)) {
                tabs.push(tabId);
                localStorage.setItem(STORE_KEY, JSON.stringify(tabs));
            }
        } catch (e) {
            console.error("Failed to save guest tab", e);
        }
    },

    // Get the manual member ID ("Me") for a specific tab
    getGuestIdForTab: (tabId: string): string | null => {
        try {
            const stored = localStorage.getItem(MANUAL_MEMBER_MAP_KEY);
            const map = (stored ? JSON.parse(stored) : {}) as GuestTabMap;
            return map[tabId] ?? null;
        } catch {
            return null;
        }
    },

    // Save the manual member ID ("Me") for a specific tab
    saveGuestIdForTab: (tabId: string, manualMemberId: string) => {
        try {
            const stored = localStorage.getItem(MANUAL_MEMBER_MAP_KEY);
            const map = (stored ? JSON.parse(stored) : {}) as GuestTabMap;
            map[tabId] = manualMemberId;
            localStorage.setItem(MANUAL_MEMBER_MAP_KEY, JSON.stringify(map));

            // Also ensure the tab is in the list
            GuestService.saveGuestTab(tabId);
        } catch (e) {
            console.error("Failed to save guest map", e);
        }
    },

    // Clear all guest data (e.g. on logout)
    clearAll: () => {
        try {
            localStorage.removeItem(STORE_KEY);
            localStorage.removeItem(MANUAL_MEMBER_MAP_KEY);
        } catch (e) {
            console.error("Failed to clear guest data", e);
        }
    }
};
